// Settings — how each analysis' deficiency is correlated to a crash, with a
// switch per rule. A disabled rule drops that analysis' findings everywhere
// the dashboard reads them (Insights, popups, Correlated-only, cluster
// insights, CMF matching of correlated crashes). Persisted per browser.
import React, { useEffect } from 'react';
import { CORRELATION_RULES } from './safetyFilters';

export const DISABLED_RULES_STORAGE_KEY = 'safety:disabledRules';

export function loadDisabledRules() {
  try {
    const raw = window.localStorage.getItem(DISABLED_RULES_STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((k) => CORRELATION_RULES.some((r) => r.key === k)) : [];
  } catch (e) {
    return [];
  }
}
export function saveDisabledRules(rules) {
  try { window.localStorage.setItem(DISABLED_RULES_STORAGE_KEY, JSON.stringify(rules)); } catch (e) { /* private mode */ }
}

export default function SettingsDialog({ open, onClose, disabledRules, onChange }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;

  const toggle = (key) => {
    const next = disabledRules.includes(key)
      ? disabledRules.filter((k) => k !== key)
      : [...disabledRules, key];
    onChange(next);
  };

  return (
    <div className="safety-modal-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="safety-modal" role="dialog" aria-modal="true" aria-labelledby="safety-settings-title">
        <div className="safety-modal-head">
          <h2 id="safety-settings-title">Correlation rules</h2>
          <button type="button" className="lg-close" onClick={onClose} title="Close">×</button>
        </div>
        <p className="safety-muted safety-modal-lede">
          A crash is <em>correlated</em> when it occurred at a location where an RDV analysis found a
          deficiency — the rule below is applied per analysis. Switch a rule off to exclude that
          analysis from every correlation view; the deficiency runs themselves stay on the map.
        </p>
        <ul className="safety-rules">
          {CORRELATION_RULES.map((r) => {
            const on = !disabledRules.includes(r.key);
            return (
              <li key={r.key} className={on ? '' : 'off'}>
                <label className="safety-rule-head">
                  <input type="checkbox" checked={on} onChange={() => toggle(r.key)} />
                  <span className={`safety-an safety-an-${r.key}`}>{r.key}</span>
                  <span className="safety-rule-title">{r.title}</span>
                  <span className={`safety-chip ${on ? 'safety-chip-ok' : 'safety-chip-neutral'}`}>{on ? 'enabled' : 'disabled'}</span>
                </label>
                <p className="safety-rule-text">{r.rule}</p>
              </li>
            );
          })}
        </ul>
        <div className="safety-modal-foot">
          <span className="safety-muted">
            Common to all rules: station gate 0.02 mi, site buffer ±0.1 mi, crashes deduplicated by crash number,
            animal strikes never enter the cost figures.
          </span>
          <div className="row-actions">
            <button type="button" className="safety-btn safety-btn-ghost" onClick={() => onChange([])}>Enable all</button>
            <button type="button" className="safety-btn" onClick={onClose}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
}
